<template>
  <footer>
    <div class="brand">
      <img src="../../../assets/wb/wb_logo.png" alt="" />
    </div>
    <div class="options">
      <div class="social">
        <div class="title">{{ data.text_1 }}</div>
        <div class="links">
          <a href="#" class="item">
            <img src="" alt="" />
            <span>{{ data.text_2 }}</span>
          </a>
          <a href="#" class="item">
            <img src="" alt="" />
            <span>{{ data.text_3 }}</span>
          </a>
          <a href="#" class="item">
            <img src="" alt="" />
            <span>{{ data.text_4 }}</span>
          </a>
        </div>
      </div>
      <div class="site_info">
        <span>{{ data.text_5 }}</span>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    data: {
      text_1: "Follow us",
      text_2: "Twitter",
      text_3: "Facebook", 
      text_4: "LinkedIn",
      text_5: "© 2020 Skooly",
    },
  },
};
</script>
<style>
footer {
  text-align: center;
  background-color: #1b212c;
  padding: 1rem 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

footer .brand img {
  width: 30px;
}
footer .options {
  padding: 0rem 1rem;
  width: 80%;
  text-align: right;
}
footer .options a {
  color: #fff;
  text-decoration: none;
}
</style>